import { Injector, ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SharedModule } from 'app/shared/shared.module';
// import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { WorkflowsComponent } from './workflows/workflows.component';
import { DataCollectorService } from './utility/data_collector.service';
const httpLoaderFactory = (http: HttpClient): any =>new TranslateHttpLoader(http,'../../../src/assets/i18n/en.json','.json');

// AoT requires an exported function for factories

const providers = [
  DataCollectorService
];

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    TranslateModule.forRoot({
      loader:{
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps:[HttpClient]
      }
  }),
  ],
  providers: providers,
  bootstrap: [AppComponent]
})

export class AppModule {
}

@NgModule({})
export class WorkflowBuilderModule{
  static forRoot(): ModuleWithProviders<AppModule> {
    return {
      ngModule: AppModule,
      providers: providers
    };
  }
}
